export var ViewType;
(function (ViewType) {
    ViewType["SECTION_VIEW"] = "sectionView";
    ViewType["ALTITUDE_VIEW"] = "altitudeView";
    ViewType["CESIUM_VIEW"] = "cesiumView";
    ViewType["MEASUREMENT_VIEW"] = "measurementView";
    ViewType["LINE_SECTION_VIEW"] = "lineSectionView";
    ViewType["LINE_PROFILE_VIEW"] = "lineProfileView";
})(ViewType || (ViewType = {}));
export var CESIUM_PICKABLE_ENTITY;
(function (CESIUM_PICKABLE_ENTITY) {
    CESIUM_PICKABLE_ENTITY["ALIGNMENT_POINT"] = "alignment-point";
    CESIUM_PICKABLE_ENTITY["ROAD_CONTROL_POINT"] = "road-control-point";
    CESIUM_PICKABLE_ENTITY["ROAD_PATH"] = "road-path";
    CESIUM_PICKABLE_ENTITY["ROAD_CENTER_LINE"] = "road-center-line";
    CESIUM_PICKABLE_ENTITY["ROAD_GEOMETRY"] = "road-geometry";
    CESIUM_PICKABLE_ENTITY["ROAD_EMBARKMENT_GEOMETRY"] = "road-embarkment-geometry";
    CESIUM_PICKABLE_ENTITY["ROAD_CUT_GEOMETRY"] = "road-cut-geometry";
    CESIUM_PICKABLE_ENTITY["FLAT_GROUND_EDIT_OUTLINE"] = "flat-ground-edit-outline";
    CESIUM_PICKABLE_ENTITY["FLAT_GROUND_CONTROL_POINT"] = "flat-ground-control-point";
    CESIUM_PICKABLE_ENTITY["FLAT_GROUND_CONTROL_POINT_ARROW"] = "flat-ground-control-point-arrow";
    CESIUM_PICKABLE_ENTITY["FLAT_GROUND_CENTRAL_ARROW"] = "flat-ground-central-arrow";
    CESIUM_PICKABLE_ENTITY["FLAT_GROUND_GEOMETRY"] = "flat-ground-geometry";
    CESIUM_PICKABLE_ENTITY["FLAT_GROUND_EMBARKMENT_GEOMETRY"] = "flat-ground-embarkment-geometry";
    CESIUM_PICKABLE_ENTITY["FLAT_GROUND_CUT_GEOMETRY"] = "flat-ground-cut-geometry";
    CESIUM_PICKABLE_ENTITY["POINTCLOUD_TILESET"] = "pointcloud-tileset";
    CESIUM_PICKABLE_ENTITY["TRENCH_CONTROL_POINT"] = "trench-control-point";
    CESIUM_PICKABLE_ENTITY["TRENCH_SEGMENT"] = "trench-segment";
    CESIUM_PICKABLE_ENTITY["TRENCH_CENTER_LINE"] = "trench-center-line";
    CESIUM_PICKABLE_ENTITY["TRENCH_GEOMETRY"] = "trench-geometry";
    CESIUM_PICKABLE_ENTITY["TRENCH_CUT_GEOMETRY"] = "trench-cut-geometry";
    CESIUM_PICKABLE_ENTITY["ARBITRARY_LINE_CONTROL_POINT"] = "arbitrary-line-control-point";
    CESIUM_PICKABLE_ENTITY["LINEWORKS_CROSS_SECTION_RIGHT"] = "lineworks-cross-section-right";
    CESIUM_PICKABLE_ENTITY["LINEWORKS_CROSS_SECTION_LEFT"] = "lineworks-cross-section-left";
    CESIUM_PICKABLE_ENTITY["SIMA_LINE_POINT"] = "sima-line-point";
    CESIUM_PICKABLE_ENTITY["ALIGNMENT_IP_POINT"] = "alignment-ip-point";
})(CESIUM_PICKABLE_ENTITY || (CESIUM_PICKABLE_ENTITY = {}));
export var CESIUM_NONPICKABLE_ENTITY;
(function (CESIUM_NONPICKABLE_ENTITY) {
    CESIUM_NONPICKABLE_ENTITY["PREVIEW_HOVER_POINT"] = "preview-hover-point";
    CESIUM_NONPICKABLE_ENTITY["DESIGN_DATA_TILESET"] = "design-data-tileset";
})(CESIUM_NONPICKABLE_ENTITY || (CESIUM_NONPICKABLE_ENTITY = {}));
export var AssetType;
(function (AssetType) {
    AssetType["Point_Cloud"] = "pointcloud";
    AssetType["Design_Data"] = "design";
    AssetType["Road_Data"] = "road";
    AssetType["Flat_Ground_Data"] = "flatground";
    AssetType["Trench_Data"] = "trench";
    AssetType["DXF_Data"] = "dxf";
    AssetType["ArbitraryLine_Data"] = "arbitrary-line";
    AssetType["ArbitraryLine_CROSS_SECTION"] = "arbitrary-line-cross-section";
    AssetType["SIMA_Data"] = "SIMA";
    AssetType["REFERENCE_TOPOLOGY"] = "reference-topology";
    AssetType["SOLID_MESH"] = "solid-mesh";
    AssetType["ALIGNMENT"] = "alignment";
    AssetType["Spreading_Compaction_Data"] = "spreading-compaction";
    AssetType["UNKNOWN"] = "unknown";
})(AssetType || (AssetType = {}));
/** Reads the pickInfo that renderables attach to entities via Entity.addProperty. */
export const getEntityPickInfo = (entity) => entity.pickInfo;
export var EmbankmentType;
(function (EmbankmentType) {
    EmbankmentType["FILL"] = "fill";
    EmbankmentType["CUT"] = "cut";
    EmbankmentType["NONE"] = "none";
})(EmbankmentType || (EmbankmentType = {}));
export var Side;
(function (Side) {
    Side["LEFT"] = "left";
    Side["RIGHT"] = "right";
    Side["CENTER"] = "center";
})(Side || (Side = {}));
export var SegmentType;
(function (SegmentType) {
    SegmentType["STRAIGHT"] = "straight";
    SegmentType["CURVE"] = "curve";
    SegmentType["ARC"] = "arc";
    SegmentType["NONE"] = "none";
})(SegmentType || (SegmentType = {}));
//# sourceMappingURL=types.js.map